// this is a model proposal.
// we could discuss it on refactoring session
// - all public (risks?)
// - get rid of mappers in favour of new 'from' static method on model

export class ProgressModel {
  constructor(
    public createdClients: boolean,
    public createdQuotes: boolean,
    public updatedDashboard: boolean,
  ) {}

  public static from(data: any): ProgressModel {
    if (!data) {
      return null;
    }

    return new ProgressModel(
      data.createdClients,
      data.createdQuotes,
      data.updatedDashboard,
    );
  }

  public isDone(): boolean {
    return this.createdClients && this.createdQuotes && this.updatedDashboard;
  }
}
